<app-only-table-generator
    *ngIf="tableGenInput && apiInfo"
    [tableInput]="tableGenInput"
    [apiInfo]="apiInfo"
></app-only-table-generator>
